"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.modifierToNumber = void 0;
var isTypeString_1 = require("../../typeGuards/isTypeString");
var isTypeNumber_1 = require("../../typeGuards/isTypeNumber");
var modifierToNumber = function (value) {
    if (isTypeNumber_1.isTypeNumber(value)) {
        return value;
    }
    if (!isTypeString_1.isTypeString(value)) {
        throw new Error('UseForm: Value should be a string');
    }
    var modifiedValue = "";
    for (var _i = 0, value_1 = value; _i < value_1.length; _i++) {
        var character = value_1[_i];
        if (["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "."].includes(character)) {
            if (character === "." && modifiedValue.includes('.')) {
                continue;
            }
            modifiedValue = modifiedValue + character;
        }
    }
    if (modifiedValue.includes('.')) {
        return parseFloat(modifiedValue);
    }
    return parseInt(modifiedValue);
};
exports.modifierToNumber = modifierToNumber;
//# sourceMappingURL=modifierToNumber.js.map